// src/lib/ordenarLista.js — ordenação das listas via CABEÇALHO CLICÁVEL.
// Clica no <th>: 1x ordena no sentido padrão da coluna, 2x inverte, 3x volta. Mostra seta ▲/▼.
// Modo = `${key}_${dir}` com key ∈ {data,valor,nome} e dir ∈ {asc,desc}.
// A lista passa acessores: { data(row), valor(row), nome(row) }. 'data' deve devolver ISO/comparável.

// Sentido do 1º clique por tipo de coluna: valor/data começam decrescente (maior/mais recente),
// nome começa crescente (A–Z).
const _DEFAULT_DIR = { valor: 'desc', data: 'desc', nome: 'asc' };

// Próximo modo ao clicar na coluna `key`, dado o modo atual.
export function nextSortMode(current, key) {
  const def = _DEFAULT_DIR[key] || 'asc';
  const inv = def === 'asc' ? 'desc' : 'asc';
  if (current === `${key}_${def}`) return `${key}_${inv}`; // 2º clique inverte
  if (current === `${key}_${inv}`) return `${key}_${def}`; // 3º clique volta ao padrão da coluna
  return `${key}_${def}`;                                   // 1º clique
}

// <th> clicável com indicador de ordenação.
// opts: { align:'right', cls:'hide-md', style:'…' }
export function thSort(label, key, current, handler, opts = {}) {
  const active = typeof current === 'string' && current.startsWith(`${key}_`);
  const dir = active ? current.slice(key.length + 1) : '';
  const arrow = active ? (dir === 'asc' ? '↑' : '↓') : '';
  const align = opts.align === 'right' ? 'text-align:right;' : '';
  const cls = opts.cls ? ` class="${opts.cls}"` : '';
  const style = `cursor:pointer;user-select:none;white-space:nowrap;${align}${opts.style || ''}`;
  return `<th${cls} style="${style}" onclick="${handler}('${key}')" title="Ordenar por ${label}">`
    + `${label}${arrow ? ` <span style="opacity:.75;font-weight:700">${arrow}</span>` : `<span style="opacity:.35"> ⇅</span>`}</th>`;
}

const _num = (x) => Number(x) || 0;
const _str = (x) => String(x ?? '').toLowerCase();
const _dt = (x) => String(x ?? '');

// Devolve NOVO array ordenado (estável). mode '' → retorna o array como veio (ordem padrão da lista).
export function aplicarOrdem(arr, mode, acc = {}) {
  if (!mode || !Array.isArray(arr)) return arr;
  const a = arr.slice();
  const d = acc.data || (() => ''); const v = acc.valor || (() => 0); const n = acc.nome || (() => '');
  switch (mode) {
    case 'data_desc': return a.sort((x, y) => _dt(d(y)).localeCompare(_dt(d(x))));
    case 'data_asc': return a.sort((x, y) => _dt(d(x)).localeCompare(_dt(d(y))));
    case 'valor_desc': return a.sort((x, y) => _num(v(y)) - _num(v(x)));
    case 'valor_asc': return a.sort((x, y) => _num(v(x)) - _num(v(y)));
    case 'nome_asc': return a.sort((x, y) => _str(n(x)).localeCompare(_str(n(y))));
    case 'nome_desc': return a.sort((x, y) => _str(n(y)).localeCompare(_str(n(x))));
    default: return a;
  }
}
